<script>
/**
 * ****************************************************************************
 * @description     :   Switch Component (PTJ mobile)
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @note            :   Copied from AnsSwitch — same behavior & template.
 * ****************************************************************************
 */

import template from './template.html';
import helpers from '@/utils/helpers';

var PtjSwitch = {
    name: 'PtjSwitch',
    template: template,
    props: {
        id: String,
        label: String,
        checkboxLabel: [String, Number],
        itemClass: String,
        labelClass: String,
        inputClass: String,
        isShowCheckbox: {
            type: Boolean,
            default: false
        },
        isAlwaysEnable: {
            type: Boolean,
            default: false
        },
        typeCheck: {
            type: String,
            default: 'checkbox'
        },
        modelValue: {
            type: [String, Number],
            default: '0'
        },
        isDisabled: Boolean,
        isRequired: Boolean,
        onChange: Function,
        arrUncheck: {
            type: Array,
            default: [undefined, null, '', false, 'false', 0, '0']
        },
        arrValue: {
            type: Object,
            default: {
                unchecked: {
                    value: '0'
                },
                checked: {
                    value: '1'
                }
            }
        },
        additionalInput: {
            type: Boolean,
            default: false
        },
        inputText: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue', 'referOptionalInput'],
    data() {
        return {
            text: '',
            modeDisabled: false
        };
    },
    created() {
        if (!['MNG_Order001', 'MNG_System002', 'MNG_System004', 'MNG_File001'].includes(this.$route.name)) {
            this.modeDisabled = helpers.checkAuthorityMode(this.$route.name) && !this.isAlwaysEnable;
        }
    },
    computed: {
        checked() {
            if (this.arrUncheck.includes(this.modelValue)) {
                this.value = this.arrValue.unchecked.value;
                return false;
            }
            this.value = this.arrValue.checked.value;
            return true;
        }
    },
    mounted() {
        this.text = this.inputText;
    },
    watch: {
        modelValue(val) {
            if (val == 0) {
                this.text = '';
            }
        },
        inputText(val) {
            this.text = val;
        }
    },
    methods: {
        updateInput(e) {
            let checked;
            if (this.typeCheck == 'radio' && this.checked) {
                checked = this.checked;
            } else {
                checked = !this.checked;
            }
            const value = checked ? this.arrValue.checked.value : this.arrValue.unchecked.value;
            this.$emit('update:modelValue', value);

            if (this.onChange) {
                this.onChange(e, value);
            }
            if (this.additionalInput) {
                this.$nextTick(() => {
                    var nameInput = 'input_switch_' + e.target.id;
                    const input = document.getElementById(nameInput);
                    input.focus();
                    if (input) {
                        input.focus();
                    }
                });
            }
        },
        updateAddInput() {
            this.$emit('referOptionalInput', this.text);
        }
    }
};
export default PtjSwitch;
</script>
